
import styled from 'styled-components';

export const NextButton = styled.button`
    width: 128px;
    height: 40px;
    margin: 0px 32px;
    transition: background-color 0.2s ease, color 0.2s ease;
    background-color: #FF7203;
    color: white;
    font-weight: bold;
    border-width: 0;

  :disabled {
    border-color: lightgrey;
    color: lightgrey;
    background-color: #AAAAAA;
    color: white;
  }

  :hover:not([disabled]) {
      cursor: pointer;
      background-color: #FF7203;
      color: white;
  }
`;

export const BackButton = styled.button`
    width: 128px;
    height: 40px;
    margin: 0px 32px;
    transition: background-color 0.2s ease, color 0.2s ease;
    background-color: #626368;
    color: white;
    font-weight: bold;
    border-width: 0;

  :disabled {
    border-color: lightgrey;
    color: lightgrey;
    background-color: #626368;
    color: white;
  }

  :hover:not([disabled]) {
      cursor: pointer;
      background-color: #FF7203;
      color: white;
  }
`;

export const NextButtonCompact = styled.button`
    width: 96px;
    height: 30px;
    margin: 4px 16px;
    font-size: calc(0.4em + 0.4vw);
    transition: background-color 0.2s ease, color 0.2s ease;
    background-color: #FF7203;
    color: white;
    font-weight: bold;
    border-width: 0;

  :disabled {
    border-color: lightgrey;
    color: lightgrey;
    background-color: #AAAAAA;
    color: white;
  }

  :hover:not([disabled]) {
      cursor: pointer;
      background-color: #FF7203;
      color: white;
  }
`;

export const BackButtonCompact = styled.button`
    width: 96px;
    height: 30px;
    margin: 4px 16px;
    font-size: calc(0.4em + 0.4vw);
    transition: background-color 0.2s ease, color 0.2s ease;
    background-color: #626368;
    color: white;
    font-weight: bold;
    border-width: 0;

  :disabled {
    border-color: lightgrey;
    color: lightgrey;
    background-color: #626368;
    color: white;
  }

  :hover:not([disabled]) {
      cursor: pointer;
      background-color: #FF7203;
      color: white;
  }
`;
